<template>
  <div class="md-layout text-center">
    <div class="md-layout-item md-size-50 md-small-size-100 md-xsmall-size-100 logo-main">
      <img :src="logo" alt="">
    </div>
    <div class="md-layout-item md-size-50 md-small-size-100">
      <OutsideNotifs v-if="notifShow" v-bind:message="notifMessage" v-bind:hasError="errorNotif" v-on:closeNotif="showNotif"/>
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(projectLogin)">
      <login-card>
        <div slot="login-header" class="login-header-wrapper">
          <h3 class="page-title">Select Your Password</h3>
        </div>
        <div slot="inputs">
            <ValidationProvider
              name="password"
              rules="required|min:6"
              v-slot="{ errors, passed, failed }"
            >
              <md-field class="md-form-group" :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                <md-icon>lock_outline</md-icon>
                <label>Password</label>
                <md-input v-model="password" type="password"></md-input>
                <span class="md-helper-text"
                  >Your password should be 6 characters long.</span
                >
                <!-- <span class="md-helper-text"
                  >{errors}</span
                > -->
                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </ValidationProvider>
            <ValidationProvider
              vid="confirmation"
              rules="required|confirmed:password"
              v-slot="{ passed, failed }"
            >
              <md-field class="md-form-group" :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                <md-icon>lock_outline</md-icon>
                <label>Retype Password</label>
                <md-input
                  v-model="passwordConfirmation"
                  type="password"
                ></md-input>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </ValidationProvider>
    </div>
        <md-button
          @click="acceptInvite"
          slot="footer"
          class="md-simple md-success md-lg submit"
        >
          Create Password
        </md-button>
      </login-card>
      </form>
    </ValidationObserver>
    </div>
  </div>
</template>
<script>
import { LoginCard } from "@/components";
import { extend } from "vee-validate";
import { required, email, confirmed } from "vee-validate/dist/rules";
import api from '@/api';
import OutsideNotifs from "@/pages/Dashboard/UserPages/Components/OutsideNotifs.vue"

import axios from 'axios';
import { getParam } from '../../../helpers';
export default {
  components: {
    LoginCard,
    OutsideNotifs
  },
  props: {
    logo: {
      type: String,
      default: "./img/mainscs_logo.png"
    },
  },
  data() {
    return {
      password: null,
      passwordConfirmation: null,
      notifMessage: '',
      errorNotif: false,
      notifShow: false,
    }
  },
  methods: {
    //TODO refactor into function call in src/api.js
    acceptInvite(){
      var obj = {
        user: {
          password: this.password,
          password_confirmation: this.passwordConfirmation,
          invitation_token: getParam('invitation_token')
        }
      }
      api.acceptInvite(obj).then((response) => {
        this.changeNotif("Your password has saved. Please log into SafeCore", false)
        this.$router.push("/projectportal");
      }).catch((e) => {
        this.changeNotif("There was an error resetting your password. Please try again.", true)
        console.log(e)
      })
    },
    changeNotif(message, type){
      this.notifMessage = message;
      this.errorNotif = type;
      this.notifShow = true;
    }
  }
}
</script>
